
(function () {
  const $ = require('jQuery');

  const gGlobalEnv = {
    platform  : 'pendant',
    page      : 'configuration'
  };

  function isPlatformValid(pPlatform) {
    switch (pPlatform) {
      case 'pendant':
      case 'cad':
        return true;
      default:
        console.error('Unknown platform: ' + pPlatform);
        return false;
    }
  }

  function isPageValid(pPage) {
    switch (pPage) {
      case 'configuration':
      case 'configuration_checker':
      case 'application':
      case 'uibuilder':
      case 'launcher':
      case 'machineapp':
      case 'application_landing_page':
      case 'python':
        return true;
      default:
        console.error("Unknown page:", pPage);
        return false;
    }
  }

  function setEnvironment(pPlatform, pPage) {
    console.log('Environment set to: platform=' + pPlatform + ', page=' + pPage);
    if (isPlatformValid(pPlatform)) {
      $("body").attr("platform", pPlatform); // Can use this in CSS to set styles specific to the platform when there's no other alternatives
      gGlobalEnv.platform = pPlatform;
    }

    if (isPageValid(pPage)) {
      gGlobalEnv.page = pPage;
    }
  }

  function changePlatform(pPlatform) {
    if (!isPlatformValid(pPlatform)) {
      return;
    }

    gGlobalEnv.platform = pPlatform;
  }

  function changePage(pPage) {
    if (!isPageValid(pPage)) {
      return;
    }

    gGlobalEnv.page = pPage;
  }

  function getEnvironment() {
    return gGlobalEnv;
  }

  function getPage() {
    return gGlobalEnv.page;
  }

  function getPlatform() {
    return gGlobalEnv.platform;
  }

  function isOnPendant() { return gGlobalEnv.platform === 'pendant'; }
  function isOnCad() { return gGlobalEnv.platform === 'cad'; }

  function isOnConfigCheckerPage() { return gGlobalEnv.page === 'configuration_checker'; }
  function isOnConfigPage() { return gGlobalEnv.page === 'configuration' || isOnConfigCheckerPage(); }
  function isOnAppPage() { return gGlobalEnv.page === 'application'; }
  function isOnUiBuilderPage() { return gGlobalEnv.page === 'uibuilder'; }
  function isOnMachineAppPage() { return gGlobalEnv.page === 'machineapp'; }
  function isOnLauncherPage() { return gGlobalEnv.page === 'launcher'; }

  if (window != undefined) {
    window.getEnvironment = getEnvironment;
    window.setEnvironment = setEnvironment;
    window.changePage = changePage;
  }

  /* Module export glue */
  /* global define */
  const gExports = {
    setEnvironment: setEnvironment,
    changePlatform: changePlatform,
    changePage: changePage,

    getEnvironment: getEnvironment,
    getPage: getPage,
    getPlatform: getPlatform,

    isOnPendant: isOnPendant,
    isOnCad: isOnCad,

    isOnConfigPage: isOnConfigPage,
    isOnAppPage: isOnAppPage,
    isOnUiBuilderPage: isOnUiBuilderPage,
    isOnMachineAppPage: isOnMachineAppPage,
    isOnLauncherPage: isOnLauncherPage,
    isOnConfigCheckerPage: isOnConfigCheckerPage
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
}());
